import { render, staticRenderFns } from "./web-app.vue?vue&type=template&id=42675de5&scoped=true&"
import script from "./web-app.vue?vue&type=script&lang=js&"
export * from "./web-app.vue?vue&type=script&lang=js&"
import style0 from "./web-app.vue?vue&type=style&index=0&id=42675de5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42675de5",
  null
  
)

export default component.exports